import React, { useState, useEffect } from "react";
import {
    Navbar,
    Nav,
    Container,
    Form,
    FormControl,
    Button,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import BreakingNews from "./BreakingNews";
import "./header.css";

const siteLogo = `${process.env.PUBLIC_URL}/img/Logo.png`;

const BASE = (() => {
    let url = process.env.REACT_APP_API_URL || "https://news-portal-l6pf.onrender.com";
    url = url.replace(/\/$/, "");
    if (url.endsWith("/api")) url = url.slice(0, -4);
    return url;
})();

const CATEGORY_API = `${BASE}/api/news/categories`;

const changeLanguage = (lang) => {
    const select = document.querySelector(".goog-te-combo");
    if (select) {
        select.value = lang;
        select.dispatchEvent(new Event("change"));
    }
};

// Custom Dropdown Component
const HoverDropdown = ({ title, items, id, isBreaking = false }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <li
            className="nav-item dropdown"
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
        >
            <a
                className="nav-link dropdown-toggle"
                href="#"
                onClick={(e) => e.preventDefault()}
            >
                {isBreaking ? <span className="nav-breaking">{title}</span> : title}
            </a>
            <ul className={`dropdown-menu ${isOpen ? 'show' : ''}`}>
                {items.map((item, index) => (
                    <li key={index}>
                        <Link className="dropdown-item" to={item.path}>
                            {item.name}
                        </Link>
                    </li>
                ))}
            </ul>
        </li>
    );
};

const NewsHeader = () => {
    const [search, setSearch] = useState("");
    const [categories, setCategories] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            const res = await fetch(CATEGORY_API);
            const result = await res.json();
            const categoriesData = result?.categories || result?.data || [];
            setCategories(Array.isArray(categoriesData) ? categoriesData : []);
        } catch (err) {
            console.error("Fetch categories error:", err);
        }
    };

    // Group categories by group
    const groupedCategories = categories.reduce((acc, cat) => {
        const group = cat.group || "General";
        if (!acc[group]) acc[group] = [];
        acc[group].push({
            name: cat.name,
            path: `/category/${encodeURIComponent(cat.name)}`
        });
        return acc;
    }, {});

    // Map groups to dropdowns
    const myGujaratItems = groupedCategories["Maru Gujarat"] || [];
    const indiaStatesItems = groupedCategories["India"] || [];
    const breakingNewsItems = groupedCategories["Proudtapi"] || groupedCategories["General"] || [];
    const worldItems = groupedCategories["World"] || [];

    const handleSearch = (e) => {
        e.preventDefault();
        if (!search.trim()) return;
        navigate(`/search?q=${encodeURIComponent(search)}`);
        setSearch("");
    };

    return (
        <>
            <div id="google_translate_element" style={{ display: "none" }} />

            {/* Breaking News Ticker */}
            <BreakingNews />

            {/* Top Header */}
            <div className="top-header">
                <Container className="d-flex align-items-center justify-content-between gap-4 py-3">

                    {/* Logo with Tagline */}
                    <div className="header-brand">
                        <Link to="/" className="brand-link">
                            <img src={siteLogo} alt="Proudtapi" className="brand-logo" />

                            <div className="news-ticker">
                                <div className="ticker-track">

                                </div>
                            </div>
                        </Link>
                    </div>

                    {/* Search */}
                    <Form className="search-bar-wrapper" onSubmit={handleSearch}>
                        <FormControl
                            type="search"
                            placeholder="Find the article..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="search-input-field"
                        />
                        <Button type="submit" className="search-btn-icon">
                            🔍
                        </Button>
                    </Form>

                    {/* Right Actions */}
                    <div className="header-actions">
                        <Link to="/epaper" className="epaper-btn">
                            📰 E-Paper
                        </Link>

                        <div className="lang-buttons-group">
                            <button className="lang-btn active" onClick={() => changeLanguage("gu")}>
                                GUJ
                            </button>
                            <button className="lang-btn" onClick={() => changeLanguage("en")}>
                                EN
                            </button>
                            <button className="lang-btn" onClick={() => changeLanguage("hi")}>
                                HIN
                            </button>
                        </div>
                    </div>
                </Container>
            </div>

            {/* MAIN NAVBAR */}
            <Navbar className="main-navbar" expand="lg" sticky="top">
                <Container>
                    <Navbar.Toggle aria-controls="main-navbar-nav" />
                    <Navbar.Collapse id="main-navbar-nav">
                        <Nav as="ul" className="w-100 justify-content-center gap-2">

                            <Nav.Item as="li">
                                <Nav.Link as={Link} to="/">Home</Nav.Link>
                            </Nav.Item>

                            <Nav.Item as="li">
                                <Nav.Link as={Link} to="/special">ProudTaapi Special</Nav.Link>
                            </Nav.Item>

                            <Nav.Item as="li">
                                <Nav.Link as={Link} to="/top-news">Top News</Nav.Link>
                            </Nav.Item>

                            {/* My Gujarat Dropdown */}
                            <HoverDropdown
                                title="My Gujarat"
                                items={myGujaratItems}
                                id="my-gujarat-dropdown"
                            />

                            {/* India States Dropdown */}
                            <HoverDropdown
                                title="India States"
                                items={indiaStatesItems}
                                id="india-dropdown"
                            />

                            {/* Breaking News Dropdown */}
                            <HoverDropdown
                                title="Breaking News"
                                items={breakingNewsItems}
                                id="breaking-dropdown"
                                isBreaking={true}
                            />

                            {/* World Dropdown */}
                            <HoverDropdown
                                title="World"
                                items={worldItems}
                                id="world-dropdown"
                            />

                            <Nav.Item as="li">
                                <Nav.Link as={Link} to="/more">More</Nav.Link>
                            </Nav.Item>

                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
};

export default NewsHeader;